export const TOP_SPACE_WITH_TICKER = [11, 12, 14];
export const MUI_TOP_SPACE_WITH_TICKER = { xs: 88, sm: 96, md: 112 };
